module.exports = __webpack_public_path__ + "img/GoalSport_Logo_Final_NoSlogan.f5b6313d.png";